import { MainArea, Page, TopArea } from '@salecycle/ui-component-library';
import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';
import * as React from 'react';
import { NewCampaignProvider } from '../context/UseNewCampaignContext';
import NewCampaignWizard from './NewCampaignWizard';

export const NewCampaignWizardPage: React.FC = () => (
  <NewCampaignProvider>
    <MainArea>
      <TopArea>
        <AppTopBar />
      </TopArea>

      <Page padding={0}>
        <NewCampaignWizard />
      </Page>
    </MainArea>
  </NewCampaignProvider>
);

export default NewCampaignWizardPage;
